import { render, staticRenderFns } from "./ppbkabupaten.vue?vue&type=template&id=043f33bc"
import script from "./ppbkabupaten.vue?vue&type=script&lang=js"
export * from "./ppbkabupaten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports